(function () {
    'use strict';

    angular
        .module('riskSelfAssessmentAssessControllers')
        .controller('RiskSelfAssessmentAssessRiskController', Controller);

    Controller.$inject = ['$rootScope', '$scope', '$state', '$stateParams', 'commonRiskSelfAssessmentService', 'riskSelfAssessmentAssessService', 'authenticatedAssessorID', 'isAssessor',
        'govProcess', 'criterias', 'risksToAssess', 'assessmentQuestions'];

    function Controller($rootScope, $scope, $state, $stateParams, commonRiskSelfAssessmentService, riskSelfAssessmentAssessService, authenticatedAssessorID, isAssessor,
                        govProcess, criterias, risksToAssess, assessmentQuestions) {

        if ($state.is('riskSelfAssessmentAssess.assessor') || $state.is('riskSelfAssessmentAssess.impersonateAssessor')) {

            var areAllRisksNotAssessed = _.every(risksToAssess, function (risk) { return !risk.Assessment || !risk.Assessment.RiskAssessmentID; });
            var riskToAssess = _.find(risksToAssess, function (risk) { return !risk.Assessment || !risk.Assessment.RiskAssessmentID; });

            if (areAllRisksNotAssessed) {
                $state.go('riskSelfAssessmentAssess.welcome', {}, { location: 'replace' });
                return;
            }

            if (!_.isUndefined(riskToAssess)) {
                $state.go('riskSelfAssessmentAssess.assessor.riskToAssess', { RiskID: riskToAssess.Risk.RiskID }, { location: 'replace' });
                return;
            }

            $state.go('riskSelfAssessmentAssess.summary', {}, { location: 'replace' });

            return;
        }


        var riskToAssessIndex = _.findIndex(risksToAssess, { Risk: { RiskID: $stateParams.RiskID } });
        var risksToAssessCount = risksToAssess.length;
        var risksAssessedCount = _.filter(risksToAssess, function (risk) {
            if (_.isUndefined(risk.Assessment)) return false;

            return !_.isUndefined(risk.Assessment.RiskAssessmentID);
        }).length;
        var assessmentBeforeChanges;

        $scope.govProcess = govProcess;
        $scope.risksAssessedCount = risksAssessedCount;
        $scope.risksToAssessCount = risksToAssessCount;
        $scope.riskToAssess = risksToAssess[riskToAssessIndex];
        $scope.probabilityRatings = _.filter(criterias, { RiskLookupAssessmentTypeName: 'Probability' });
        $scope.severityRatings = _.filter(criterias, { RiskLookupAssessmentTypeName: 'Severity' });
        $scope.mitigationRatings = _.filter(criterias, { RiskLookupAssessmentTypeName: 'Mitigation' });
        $scope.overallRatings = _.filter(criterias, { RiskLookupAssessmentTypeName: 'Overall' });
        $scope.isCommentRequired = false;
        $scope.isProbabilityRatingDifferent = false;
        $scope.isSeverityRatingDifferent = false;
        $scope.isMitigationRatingDifferent = false;
        $scope.view = {
            hasAssessmentQuestions: assessmentQuestions && assessmentQuestions.RiskAssessmentQuestions && assessmentQuestions.RiskAssessmentQuestions.length
        };

        if ($scope.riskToAssess.Risk && $scope.riskToAssess.Risk.RiskID) {
            riskSelfAssessmentAssessService.getRiskEvents($scope.riskToAssess.Risk).then(function (riskEvents) {
                $scope.riskEvents = riskEvents;
                if (riskEvents && riskEvents.length > 0) {
                    $scope.riskEventCssIcon = riskEvents[0].ItemCssIcon;
                }
            });
        }

        if (!_.isObject($scope.riskToAssess)) { return; }

        if (!$scope.riskToAssess.Assessment) {
            $scope.riskToAssess.Assessment = {};
        } else {
            $scope.selectedProbabilityRating = getSelectedRating(
                $scope.riskToAssess.Assessment.InitialProbabilityCode,
                $scope.probabilityRatings
             );

            $scope.selectedSeverityRating = getSelectedRating(
                $scope.riskToAssess.Assessment.InitialSeverityCode,
                $scope.severityRatings
            );

            $scope.selectedMitigationRating = getSelectedRating(
                $scope.riskToAssess.Assessment.InitialMitigationCode,
                $scope.mitigationRatings
            );

            $scope.computedOverallCriteria = getSelectedRating(
                $scope.riskToAssess.Assessment.InitialComputedOverallCode,
                $scope.overallRatings
            );

            $scope.departmentOverallCriteria = getSelectedRating(
                $scope.riskToAssess.Assessment.InitialOverallCode,
                $scope.overallRatings
            );
        }

        initPreviousAssessmentRatings();

        assessmentBeforeChanges = _.cloneDeep($scope.riskToAssess.Assessment);

        // Page is dirty
        $scope.pageIsDirty = function () {
            $rootScope.$broadcast('page-is-dirty');
        };
        $scope.pageIsNotDirty = function () {
            $rootScope.$broadcast('page-is-not-dirty');
        };

        // Ask for Acknowledgement?
        $scope.askForAcknowledgement = function () {
            return $scope.riskToAssess.Risk.IsSuggested;
        };

        // Is not acknowledged?
        $scope.isNotAcknowledged = function () {
            return $scope.riskToAssess.Assessment.IsAcknowledged === false;
        };

        // Set Acknoweldgement
        $scope.setAcknowledgement = function (isAcknowledged) {
            if (isAcknowledged === $scope.riskToAssess.Assessment.IsAcknowledged) return;

            if (isAcknowledged === false) {
                $scope.riskToAssess.Assessment.InitialComments = null;
            }

            $scope.riskToAssess.Assessment.IsAcknowledged = isAcknowledged;
            $scope.updateCommentRequirement();
            $scope.pageIsDirty();
        };

        // Ask for Closing?
        $scope.askForClosing = function () {
            return $scope.riskToAssess.Risk.RecommendClosing;
        };

        // Is closing?
        $scope.isClosing = function () {
            return $scope.riskToAssess.Assessment.InitialProposedClosing === true;
        };

        // Is not closing?
        $scope.isNotClosing = function () {
            return $scope.riskToAssess.Assessment.InitialProposedClosing === false;
        };

        // Set proposed closing
        $scope.setProposedClosing = function (isClosing) {
            $scope.riskToAssess.Assessment.InitialProposedClosing = isClosing;
            $scope.updateCommentRequirement();
            $scope.pageIsDirty();
        };

        // Set Is Accurate to true
        $scope.setIsAccurateToTrue = function () {
            $scope.riskToAssess.Assessment.InitialIsAccurate = true;
            $scope.riskToAssess.Assessment.InitialProposedRiskNameChange = null;
            $scope.riskToAssess.Assessment.InitialProposedRiskDescriptionChange = null;
            $scope.pageIsDirty();
        };

        // Set Is Accurate to false
        $scope.setIsAccurateToFalse = function () {
            $scope.riskToAssess.Assessment.InitialIsAccurate = false;
            $scope.riskToAssess.Assessment.InitialProposedRiskNameChange =
                    $scope.riskToAssess.Risk.Name;
            $scope.riskToAssess.Assessment.InitialProposedRiskDescriptionChange =
                    $scope.riskToAssess.Risk.Description;
            $scope.pageIsDirty();
        };

        // Show Assessment?
        $scope.showAssessment = function () {
            if (!$scope.askForAcknowledgement() && $scope.isNotClosing()) return true;

            return $scope.askForAcknowledgement() && $scope.riskToAssess.Assessment.IsAcknowledged;
        };

        // Show Ratings?
        $scope.showRatings = function () {
            return !_.isUndefined($scope.riskToAssess.Assessment.InitialIsAccurate);
        };

        $scope.updateCommentRequirement = function () {
            var isCommentRequired = false;

            // Change from previous year rating > required
            if ($scope.isProbabilityRatingDifferent || $scope.isSeverityRatingDifferent || $scope.isMitigationRatingDifferent) {
                isCommentRequired = true;

            } else if ($scope.askForAcknowledgement() && !$scope.riskToAssess.Assessment.IsAcknowledged) {
                // Suggested Risk? Only if not acknowledged
                isCommentRequired = true;

            } else if ($scope.askForClosing() && !$scope.riskToAssess.Assessment.InitialProposedClosing) {
                // Recommend Closing? Only if no to remove
                isCommentRequired = true;

            } else if (!$scope.askForAcknowledgement()
                && !$scope.askForClosing()
                && $scope.riskToAssess.Assessment.InitialProposedClosing) {

                // Otherwise > Only if not applicable
                isCommentRequired = true;
            }

            $scope.isCommentRequired = isCommentRequired;
        };

        // Set probability rating
        $scope.setProbabilityRating = function (rating) {
            if ($scope.riskToAssess.Assessment.InitialProbabilityCode) {
                $scope.riskToAssess.Assessment.InitialProbabilityCode = undefined;
                $scope.selectedProbabilityRating = null;
                $scope.isProbabilityRatingDifferent = false;
            } else {
                $scope.riskToAssess.Assessment.InitialProbabilityCode = rating.Code;
                $scope.selectedProbabilityRating = rating;
                $scope.isProbabilityRatingDifferent = $scope.previousProbabilityRating
                    && $scope.previousProbabilityRating.Code !== $scope.selectedProbabilityRating.Code;
            }

            $scope.updateCommentRequirement();
            getComputedOverallCode();
            $scope.pageIsDirty();
        };

        // Set severity rating
        $scope.setSeverityRating = function (rating) {
            if ($scope.riskToAssess.Assessment.InitialSeverityCode) {
                $scope.riskToAssess.Assessment.InitialSeverityCode = undefined;
                $scope.selectedSeverityRating = null;
                $scope.isSeverityRatingDifferent = false;
            } else {
                $scope.riskToAssess.Assessment.InitialSeverityCode = rating.Code;
                $scope.selectedSeverityRating = rating;
                $scope.isSeverityRatingDifferent = $scope.previousSeverityRating
                    && $scope.previousSeverityRating.Code !== $scope.selectedSeverityRating.Code;
            }

            $scope.updateCommentRequirement();
            getComputedOverallCode();
            $scope.pageIsDirty();
        };

        // Set mitigation rating
        $scope.setMitigationRating = function (rating) {
            if ($scope.riskToAssess.Assessment.InitialMitigationCode) {
                $scope.riskToAssess.Assessment.InitialMitigationCode = undefined;
                $scope.selectedMitigationRating = null;
                $scope.isMitigationRatingDifferent = false;
            } else {
                $scope.riskToAssess.Assessment.InitialMitigationCode = rating.Code;
                $scope.selectedMitigationRating = rating;
                $scope.isMitigationRatingDifferent = $scope.previousMitigationRating
                    && $scope.previousMitigationRating.Code !== $scope.selectedMitigationRating.Code;
            }

            $scope.updateCommentRequirement();
            getComputedOverallCode();
            $scope.pageIsDirty();
        };

        // Save and continue
        $scope.saveAndContinue = function () {
            if ($scope.view.isSaving) return;

            $scope.view.isSaving = true;

            if ($scope.isNotAcknowledged()) {
                // Reset IsAccurate
                $scope.riskToAssess.Assessment.InitialIsAccurate = true;
                $scope.riskToAssess.Assessment.InitialProposedRiskNameChange = null;
                $scope.riskToAssess.Assessment.InitialProposedRiskDescriptionChange = null;

                // Reset ratings
                $scope.riskToAssess.Assessment.InitialProbabilityCode = null;
                $scope.riskToAssess.Assessment.InitialSeverityCode = null;
                $scope.riskToAssess.Assessment.InitialMitigationCode = null;
                $scope.riskToAssess.Assessment.InitialOverallCode = null;
                $scope.riskToAssess.Assessment.InitialIsOverrideOverall = null;
            }

            riskSelfAssessmentAssessService
                .assessRiskByAssessor($scope.riskToAssess, authenticatedAssessorID)
                .then(function (riskToAssess) {
                    _.extend(risksToAssess[riskToAssessIndex], riskToAssess);

                    var risk = _.find(risksToAssess, function (risk) {
                        return !risk.Assessment || !risk.Assessment.RiskAssessmentID;
                    });

                    if (!_.isUndefined(risk)) {
                        $state.go('riskSelfAssessmentAssess.assessor.riskToAssess', { RiskID: risk.Risk.RiskID });
                    } else {
                        if ($scope.view.hasAssessmentQuestions
                            && !riskSelfAssessmentAssessService.isQuestionValid(assessmentQuestions.RiskAssessmentQuestions[0])) {
                            $state.go('riskSelfAssessmentAssess.finalQuestions');
                        } else {
                            $scope.goToSummary();
                        }
                    }
                })
                .finally(function () {
                    $scope.view.isSaving = false;
                });
        };

        // Reset Answers
        $scope.resetAnswers = function () {
            riskSelfAssessmentAssessService
                .resetAnswers(risksToAssess[riskToAssessIndex].Risk, authenticatedAssessorID)
                .then(function () {
                    $state.reload();
                });
        };

        // Show Reset Answers
        $scope.showResetAnswers = function () {
            return $scope.riskToAssess.Assessment && Object.keys($scope.riskToAssess.Assessment).length > 0;
        };

        // Go to Summary
        $scope.goToSummary = function () {
            $state.go('riskSelfAssessmentAssess.summary', {}, { reload: true });
        };

        // Is Previous button disabled?
        $scope.isPreviousBtnDisabled = function () {
            if ($scope.view.hasAssessmentQuestions) {
                return false;
            } else {
                return riskToAssessIndex === 0;
            }
        };

        // Is Next button disabled?
        $scope.isNextBtnDisabled = function () {
            if ($scope.view.hasAssessmentQuestions) {
                return false;
            } else {
                return (riskToAssessIndex + 1) === risksToAssessCount;
            }
        };

        // Go to previous page
        $scope.goToPreviousPage = function () {

            if ($scope.isPreviousBtnDisabled()) { return; }

            if (riskToAssessIndex === 0 && $scope.view.hasAssessmentQuestions) {
                // First risk, move to preliminary questions
                $state.go('riskSelfAssessmentAssess.preliminaryQuestions');
            } else {
                // Go to previous Risk
                var previousRiskIdx = riskToAssessIndex - 1;
                $state.go('riskSelfAssessmentAssess.assessor.riskToAssess', { RiskID: risksToAssess[previousRiskIdx].Risk.RiskID });
            }
        };

        // Go to next page
        $scope.goToNextPage = function () {
            if ($scope.isNextBtnDisabled()) { return; }

            var nextRiskIdx = riskToAssessIndex + 1;
            if (nextRiskIdx === risksToAssessCount) {
                // Go to final questions - button is enabled as there are final questions
                $state.go('riskSelfAssessmentAssess.finalQuestions');
            } else {
                // Go to next risk
                $state.go('riskSelfAssessmentAssess.assessor.riskToAssess', { RiskID: risksToAssess[nextRiskIdx].Risk.RiskID });
            }
        };

        // Have assessment been modified?
        $scope.hasAssessmentBeenModified = function () {
            return !_.isEqual($scope.riskToAssess.Assessment, assessmentBeforeChanges);
        };

        // Is save & continue action disabled?
        $scope.isSaveAndContinueActionDisabled = function () {
            // Is saving => disable
            if ($scope.view.isSaving) return true;

            // Enable on:

            // If Suggested And Not Acknowledged => Not disabled if comments
            if ($scope.askForAcknowledgement() && $scope.isNotAcknowledged() && $scope.riskToAssess.Assessment.InitialComments) {
                return false;
            }

            // If RecommendClosing And is closing is true => Not disabled
            if ($scope.askForClosing() && $scope.isClosing()) return false;

            // Dont ask for acknowledgement and closing and Is Closing with comments
            if (!$scope.askForAcknowledgement() && !$scope.askForClosing() && $scope.isClosing() && $scope.riskToAssess.Assessment.InitialComments) {
                return false;
            }

            // Disabled On:

            // not acknowledged and no explanation
            if ($scope.askForAcknowledgement() && $scope.isNotAcknowledged() && !$scope.riskToAssess.Assessment.InitialComments) {
                return true;
            }

            // If RecommendClosing And FinalClosing is False with no comments => disabled
            if ($scope.askForClosing() && $scope.isNotClosing() && !$scope.riskToAssess.Assessment.InitialComments) {
                return true;
            }

            if ($scope.isClosing() && !$scope.riskToAssess.Assessment.InitialComments) {
                return true;
            }

            // or is accurate question not answered
            if (_.isUndefined($scope.riskToAssess.Assessment.InitialIsAccurate)) return true;

            // or proposed risk name or description not entered when is Accurate is false
            if ($scope.riskToAssess.Assessment.InitialIsAccurate === false &&
                    (!$scope.riskToAssess.Assessment.InitialProposedRiskNameChange ||
                    !$scope.riskToAssess.Assessment.InitialProposedRiskDescriptionChange)) {
                return true;
            }

            // or ratings not assigned for each criteria
            if (_.isNil($scope.riskToAssess.Assessment.InitialOverallCode)) return true;

            // or no explanation is provided when overall is overridden
            if ($scope.riskToAssess.Assessment.InitialIsOverrideOverall &&
                    _.isUndefined($scope.riskToAssess.Assessment.InitialOverrideExplanationOverall)) return true;

            // or if comment is marked as required and not provided
            if ($scope.isCommentRequired && !$scope.riskToAssess.Assessment.InitialComments) return true;
        };

        // Helpers
        function getComputedOverallCode() {
            if (!$scope.riskToAssess.Assessment.InitialSeverityCode ||
                !$scope.riskToAssess.Assessment.InitialProbabilityCode ||
                !$scope.riskToAssess.Assessment.InitialMitigationCode) {

                $scope.riskToAssess.Assessment.InitialComputedOverallCode = null;
                $scope.riskToAssess.Assessment.InitialOverallCode = null;
                $scope.computedOverallCriteria = null;
                $scope.departmentOverallCriteria = null;

                return;
            }

            commonRiskSelfAssessmentService
                    .computeOwnerOverallCriteria(
                        $scope.riskToAssess.Assessment.InitialSeverityCode,
                        $scope.riskToAssess.Assessment.InitialProbabilityCode,
                        $scope.riskToAssess.Assessment.InitialMitigationCode
                    )
                    .then(function (computedOverallCriteria) {
                        $scope.riskToAssess.Assessment.InitialComputedOverallCode = computedOverallCriteria.Code;
                        $scope.riskToAssess.Assessment.InitialOverallCode = computedOverallCriteria.Code;

                        $scope.computedOverallCriteria = computedOverallCriteria;
                        $scope.departmentOverallCriteria = computedOverallCriteria;
                    });
        }

        function getSelectedRating(ratingCode, ratings) {
            return _.find(ratings, { Code: ratingCode });
        }

        function initPreviousAssessmentRatings() {

            if (!$scope.riskToAssess.PreviousAssessments) { return; }

            $scope.previousAssessment = $scope.riskToAssess.PreviousAssessments[0];

            $scope.previousProbabilityRating = getSelectedRating(
                $scope.previousAssessment.FinalProbabilityCode,
                $scope.probabilityRatings
             );

            $scope.previousSeverityRating = getSelectedRating(
                $scope.previousAssessment.FinalSeverityCode,
                $scope.severityRatings
            );

            $scope.previousMitigationRating = getSelectedRating(
                $scope.previousAssessment.FinalMitigationCode,
                $scope.mitigationRatings
            );

            $scope.previousComputedOverallCriteria = getSelectedRating(
                $scope.previousAssessment.FinalComputedOverallCode,
                $scope.overallRatings
            );

            $scope.previousDepartmentOverallCriteria = getSelectedRating(
                $scope.previousAssessment.FinalOverallCode,
                $scope.overallRatings
            );
        }
    }
})();
